import type { WalletAccount } from '@dynamic-labs-sdk/client';

import type { StarknetWalletAccount } from '../StarknetWalletAccount.types';

export const isStarknetWalletAccount = (
  walletAccount: WalletAccount
): walletAccount is StarknetWalletAccount => walletAccount.chain === 'STARK';
